import createCompanyOverviewStorage from "./factory";
import companyOverviewStorageProvider from "./provider";

const companyOverviewStorage = createCompanyOverviewStorage(companyOverviewStorageProvider);

export default companyOverviewStorage;
